import { useEffect, useState } from 'react';
import { TextAreaField } from '@aws-amplify/ui-react';
import { Link } from 'react-router-dom';
import { NavLink, useSearchParams } from "react-router-dom";
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import React from "react";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { API, Auth } from 'aws-amplify'
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Dropdown from 'react-bootstrap/Dropdown';
import Alert from 'react-bootstrap/Alert';

const Summarize = () => {


    const initial_input = `Input text for summarization`

    const [input, setInput] = useState(initial_input)
    const [summary, setSummary] = useState('')
    const [isBusy, setIsBusy] = useState(false)
    const [time, setTime] = useState('')
    const [start, setStart] = useState(Date.now())
    const [end, setEnd] = useState(Date.now())
    const [errorMessage, setErrorMessage] = useState('');


    const summarize = async (e) => {

        const url = "https://1gq3yxbzfa.execute-api.ca-central-1.amazonaws.com/stage/"
        const user = await Auth.currentAuthenticatedUser()
        const data = { 'input_text': input }

        if (input.length < 4600) {
            console.log('log')
            API.post('DocumentSearchUser', '/summarize',
                {
                    method: "POST",
                    body: JSON.stringify(data),
                    mode: 'cors',
                    headers: {
                        'Content-Type': 'application/json',
                        "Accept": "application/json",
                        // "Access-Control-Allow-Methods": "*",
                        // 'Access-Control-Allow-Origin': '*',
                        // 'x-api-key': 'nLq7HknRpT27UpcZHE2da76uavoH7L8d5uwtXR6X'
                        'Authorization': user.signInUserSession.idToken.jwtToken
                    }
                }
            )
                .then(response => {
                    setErrorMessage('');
                    console.log('prompt')
                    console.log(response.prompt)
                    console.log('reponse')
                    console.log(response.response)
                    // console.log(typeof(response))
                    // console.log(JSON.parse(response))
                    // setSummary(JSON.parse(response))
                    setSummary(response.response)
                })
                .then(data => {
                    console.log(summary)
                })
                .then(() => {
                    setIsBusy(isBusy => !isBusy)
                })
                .then(() => {
                    setEnd(Date.now())
                })
                .catch((err) => {
                    setIsBusy(isBusy => !isBusy)
                    console.log(err.response)
                    if (err.response.status == 406) {
                        setErrorMessage(err.response.data);
                    }
                });
        }
        else {
            alert('Please limit your input to 4600 characters')
            setIsBusy(false)
        }



        // setTime(Date())
    };
    // useEffect(() => {summarize(input)}, [])

    const Tick = (props) => {
        setTime(Date())
    }
    // useEffect(() => {Tick()}, [])
    setInterval(Tick, 0.001)


    // <p>Time: {time.substring(15,24)}</p>
    const setSampleText = () => {
        setInput('CLAUSE 5.03 Amount authorized by certificate for payment of holdback amount is due and payable on day following expiration of holdback period \
        stipulated in lien legislation applicable to Place of Work. Where lien legislation does not exist or apply, holdback amount is due and payable in accordance\
        with other legislation, industry practice, or provisions which may be agreed to between parties. Owner may retain out of holdback amount sums required by law to\
        satisfy liens against Work or, if permitted by lien legislation applicable to Place of Work, other third party monetary claims against Construction Manager which are enforceable against Owner.')

    };
    return (
        <Container>
            <Row>
                <Col>
                    <br />
                    <Breadcrumb>
                        <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>Home</Breadcrumb.Item>
                        <Breadcrumb.Item active>Summarize</Breadcrumb.Item>
                    </Breadcrumb>
                </Col>
            </Row>
            <Row>
                <Col style={{ 'padding': '25px' }}>
                    <h1>Summarize</h1>
                </Col>
            </Row>
            <Row>
                <Col>
                    <div className='text-center'>
                        <Dropdown>
                            <Dropdown.Toggle variant="secondary">
                                Example Prompt
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item onClick={() => setSampleText()}>Contract Clause 5.2 Holdback</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col style={{ 'padding': '25px' }}>
                    <h2>Original Text</h2>
                    <TextAreaField
                        alignContent={'left'}
                        value={input}
                        onChange={e => setInput(e.target.value)}
                        maxLength={4600}
                    />
                    {
                        // <p><b>Length</b>: {input.length}</p>
                    }
                </Col>
            </Row>
            <Row>
                <Col xs={5} style={{ 'paddingLeft': '25px' }}>
                    <Button
                        className="btn-block"
                        variant="primary"
                        size="sm"
                        id="button-addon2"
                        onClick={() => {
                            setIsBusy(isBusy => !isBusy)
                            // setStart(Date.now())
                            setSummary('')
                            summarize(input)
                        }}
                    >
                        Submit
                    </Button>
                </Col>
                <Col xs={5}>
                    {
                        isBusy &&
                        <Spinner animation="border" role="status" variant="primary">
                            <span className="visually-hidden">Loading...</span>
                        </Spinner>
                    }
                </Col>
                {
                    // <Col>
                    //     <p><b>Last: </b>
                    //         {start < end && (end-start)/1000} s
                    //     </p>
                    // </Col>
                }
            </Row>
            <Row style={{ 'margin-top': '1em' }} >
                <Col>
                    {errorMessage && (
                        <Alert key="danger" variant="danger">
                            {errorMessage}
                        </Alert>
                    )}
                </Col>
            </Row>
            <Row>
                <Col style={{ 'padding': '25px' }}>
                    <h2>Summarization</h2>
                    {
                        // <p><b>Summary: </b></p>
                    }
                    <TextAreaField
                        alignContent={'left'}
                        value={summary}
                        isDisabled
                        // onChange={e => setInput(e.target.value)}
                        rows="9"
                    />
                </Col>
            </Row>
            {
                // <Row>
                //     <Col>
                //         <h3>Thing</h3>

                //     </Col>
                // <Col>
                //     <h2>Input text</h2>
                //         <textarea required value={input} onChange={(e) => setInput(e.target.value)}></textarea>
                //     </Col>
                //     <Col>
                //         <h2>Summary</h2>
                //         <p>{summary.summary_text}</p>
                //     </Col>
                //     <Col>

                //     </Col>
                //     <Col>
                //         <h2>Input</h2>
                //         <p>{input}</p>
                //     </Col>
                //   </Row>
            }
        </Container>
    );
};
export default Summarize;